module.exports = __webpack_public_path__ + "ck.b3e88b163308e30d93a4.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/ck.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/ck.svg
// module chunks = styles